import { render } from "./BIcon.vue?vue&type=template&id=4c85ccc7&ts=true"
import script from "./BIcon.vue?vue&type=script&lang=ts"
export * from "./BIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__